import { Inject } from '@odinjs/odin';
import { ButtonAPI, CheckboxAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnAfterFetch, OnChange, OnClose } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { AuthenticationService } from '@philips-internal/oswald-ui-core/lib/services';
import { HtmlViewerAPI } from '@philips-internal/pending-approval-components';

import BaseController from '../../BaseController';

interface TermsOfUseData {
  dsTermo: string;
  nrSequencia: number;
}

@Controller({ component: 'layout-general', fragment: 'terms-of-use' })
class TermsOfUseController extends BaseController {

  @Inject('checkbox-agree')
    checkBoxAgree: CheckboxAPI;

  @Inject('button-confirm')
    buttonConfirm: ButtonAPI;

  @Inject('html-viewer-term')
    htmlViewer: HtmlViewerAPI;

  termsOfUseResponse: TermsOfUseData;

  @OnChange({ target: 'checkbox-agree' })
  onChangeCheckBox(e: CheckboxAPI): void {
    e.setValue(!e.getValue());
    this.buttonConfirm.setEnabled(e.getValue());
  }

  @OnAfterFetch({ target: 'fetch-terms-of-use' })
  onAfterFetchTerms(e: FetchEvent): void {
    this.termsOfUseResponse = e.data as TermsOfUseData;
  }

  @OnClose({ target: ['modal-content'] })
  onClose(): void {
    AuthenticationService.logout().then(() => {
      AuthenticationService.redirectToLogin();
    }).catch((err) => {
      throw err;
    });
  }
}
export default TermsOfUseController;
